var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14895 147.428C5.41238 157.109 16.0345 161.586 25.265 157.894C34.4996 154.2 38.7769 143.706 37.1438 133.895C36.3915 129.375 36 124.733 36 120C36 73.6081 73.6081 36 120 36C129.41 36 138.458 37.5472 146.905 40.4011C156.33 43.5859 167.376 41.0393 172.495 32.5079C177.607 23.9879 174.884 12.7941 165.698 9.00783C151.613 3.20235 136.18 0 120 0C53.7258 0 0 53.7258 0 120C0 129.437 1.08927 138.619 3.14895 147.428Z",
    fill: "url(#paint0_radial_215_231)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 240C186.274 240 240 186.274 240 120C240 88.5653 227.913 59.9537 208.133 38.559C201.382 31.256 189.927 32.5909 183.714 40.3574C177.507 48.1169 178.95 59.3449 185.218 67.056C196.961 81.5042 204 99.9301 204 120C204 166.392 166.392 204 120 204C95.8715 204 74.119 193.827 58.798 177.536C51.991 170.298 41.0572 167.366 32.5372 172.478C24.0057 177.597 21.1505 188.774 27.4923 196.44C49.5028 223.047 82.7716 240 120 240Z",
    fill: "url(#paint1_radial_215_231)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_215_231",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.944 35.5357) rotate(47.258) scale(197.443 566.927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8B50E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D04B62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EC4E22"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_215_231",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.944 35.5357) rotate(47.258) scale(197.443 566.927)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#8B50E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D04B62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EC4E22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d488f1788c25b8e9cc08931095739f5e.svg";
export { ForwardRef as ReactComponent };